import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';

const POS_MAP = {
  'top-left': { justifyContent: 'flex-start', alignItems: 'flex-start' },
  'top-center': { justifyContent: 'center', alignItems: 'flex-start' },
  'top-right': { justifyContent: 'flex-end', alignItems: 'flex-start' },
  'center-left': { justifyContent: 'flex-start', alignItems: 'center' },
  'center-center': { justifyContent: 'center', alignItems: 'center' },
  'center-right': { justifyContent: 'flex-end', alignItems: 'center' },
  'bottom-left': { justifyContent: 'flex-start', alignItems: 'flex-end' },
  'bottom-center': { justifyContent: 'center', alignItems: 'flex-end' },
  'bottom-right': { justifyContent: 'flex-end', alignItems: 'flex-end' },
};

export default function HeroSection() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get('settings/').then(r => setS(r.data)).catch(() => {}); }, []);

  const title = s ? s.hero_title : 'THE NEW COLLECTION';
  const subtitle = s ? s.hero_subtitle : '';
  const btnText = s ? s.hero_button_text : 'SHOP NOW';
  const btnLink = s?.hero_button_link || '/shop';
  const bgImage = s?.hero_image || '';
  const opacity = (s?.hero_overlay_opacity ?? 50) / 100;
  const textColor = s?.hero_text_color || '#FFFFFF';
  const textAlign = s?.hero_text_align || 'center';
  const textPos = POS_MAP[s?.hero_text_position] || POS_MAP['center-center'];
  const btnPosition = s?.hero_button_position || 'with-text';
  const btnPos = POS_MAP[btnPosition];

  const btnEl = (
    <Link to={btnLink} style={{ padding: '15px 45px', border: `1px solid ${textColor}`, color: textColor, textDecoration: 'none', fontFamily: 'Montserrat, sans-serif', fontSize: '12px', letterSpacing: '3px' }}>
      {btnText}
    </Link>
  );

  return (
    <section style={{
      height: '100vh', position: 'relative',
      background: bgImage ? `url("${bgImage}") center/cover no-repeat` : '#1a1a1a',
    }}>
      <div style={{ position: 'absolute', inset: 0, background: `rgba(0,0,0,${opacity})` }} />

      {/* Text block */}
      <div style={{ position: 'absolute', inset: 0, display: 'flex', padding: '60px 40px', ...textPos, zIndex: 1 }}>
        <div style={{ textAlign, maxWidth: 700 }}>
          {title && <h1 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '56px', fontWeight: 300, letterSpacing: '8px', marginBottom: '20px', color: textColor }}>{title}</h1>}
          {subtitle && <p style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '14px', letterSpacing: '4px', marginBottom: '40px', color: textColor, opacity: 0.85 }}>{subtitle}</p>}
          {btnPosition === 'with-text' && btnText && btnEl}
        </div>
      </div>

      {/* Independent button */}
      {btnPosition !== 'with-text' && btnPos && btnText && (
        <div style={{ position: 'absolute', inset: 0, display: 'flex', padding: '60px 40px', ...btnPos, zIndex: 2, pointerEvents: 'none' }}>
          <div style={{ pointerEvents: 'auto' }}>{btnEl}</div>
        </div>
      )}
    </section>
  );
}
